export default "__VITE_ASSET__c6390bd1__"